import classNames from 'classnames'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import {NullAsDefault} from "views/Shared";
import useRouter from 'modules/navigation/useRouter'
import React, {useContext} from 'react'
import './PageHeader.css'

export const MainPageHeader = ({
  title,
  onClose = NullAsDefault,
  className,
  children,
  extra = null,
  style,
}) => {
  const { canBack, history } = useRouter()
  const { showMainPageHeader } = useContext(LayoutContext)

  return (
    <div style={style} className={classNames('PageHeader stickyTop', className)}>
      <div
        style={{ height: 'var(--header-height)' }}
        className="flex items-center gap-2 background">
        <div className="flex items-center flex-1 gap-1">
          {title}
        </div>
        {extra}
      </div>
      {children}
    </div>
  )
}
